import * as _ from "lodash";
import {getTodayStart, stringToDate, stringToDateTime, todayIsInRange} from "./generalService";
import moment from "moment";

export const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY';

export const lessonIsLesson = (lesson) => {
  return !lesson.announcement && !lesson.dateLesson;
}

export const lessonIsExam = (lesson) => {
  return lesson.dateLesson;
}

export const lessonIsAnnouncement = (lesson) => {
  return lesson.announcement;
}

export const lessonMightBeHighlightedForDate = (lesson) => {
  return getTodayStart() >= stringToDate(lesson.startLessonDate ? lesson.startLessonDate : lesson.dateLesson).getTime()
      && getTodayStart() <= stringToDate(lesson.endLessonDate ? lesson.endLessonDate : lesson.dateLesson).getTime();
}

export const getNextLessonToEnd = (dayLessons, currentTime) => {
  return dayLessons
      .filter(lesson => (lessonIsLesson(lesson) || lessonIsExam(lesson))
          && lessonMightBeHighlightedForDate(lesson)
          && currentTime <= stringToDateTime(lesson.endLessonTime).getTime())
      .reduce((nextLessonToEnd, currentLesson) => (!nextLessonToEnd || currentLesson.endLessonTime < nextLessonToEnd.endLessonTime)
          ? currentLesson : nextLessonToEnd, null);
}

export const sortScheduleLessons = (schedule) => {
  schedule.forEach(daySchedule => daySchedule[1].sort(compareOneDayLessons));
  return schedule;
}

export const compareOneDayLessons = (lesson1, lesson2) => {
  let delta = stringToDateTime(lesson1.startLessonTime).getTime() - stringToDateTime(lesson2.startLessonTime).getTime();//сортировка по времени начала
  if (!delta) delta = stringToDateTime(lesson1.endLessonTime).getTime() - stringToDateTime(lesson2.endLessonTime).getTime();//затем по времени конца
  if (!delta && lesson1.subject && lesson2.subject) delta = lesson1.subject.localeCompare(lesson2.subject);//затем по предмету
  if (!delta && lesson1.lessonTypeAbbrev && lesson2.lessonTypeAbbrev) delta = lesson1.lessonTypeAbbrev.localeCompare(lesson2.lessonTypeAbbrev);//затем по типу пары
  return delta || lesson1.numSubgroup - lesson2.numSubgroup;//затем по подгруппе
}

export const getAllLessonsPeriods = (schedules) => {
  const periods = []

  let minStartLessonTime = null
  let maxStartLessonTime = null

  let minEndLessonTime = null
  let maxEndLessonTime = null

  schedules.forEach(([, schedule]) => {
    schedule.forEach(lesson => {
      if (!minStartLessonTime || lesson.startLessonTime < minStartLessonTime) minStartLessonTime = lesson.startLessonTime
      if (!maxStartLessonTime || lesson.startLessonTime > maxStartLessonTime) maxStartLessonTime = lesson.startLessonTime

      if (!minEndLessonTime || lesson.endLessonTime < minEndLessonTime) minEndLessonTime = lesson.endLessonTime
      if (!maxEndLessonTime || lesson.endLessonTime > maxEndLessonTime) maxEndLessonTime = lesson.endLessonTime

      if (lessonIsLesson(lesson)) periods.push({ startLessonTime: lesson.startLessonTime, endLessonTime: lesson.endLessonTime })
    })
  });

  if (!periods.length && maxEndLessonTime > minStartLessonTime) {//работает и как проверка на null`ы, так как времена – строки HH:MM
    periods.push({ startLessonTime: minStartLessonTime, endLessonTime: maxEndLessonTime })
  }

  let minStartPeriodTime = null
  let maxEndPeriodTime = null

  const uniquePeriods = [];
  const map = new Map();
  for (const item of periods) {
    if (!map.has(item.startLessonTime)) {
      if (!minStartPeriodTime || item.startLessonTime < minStartPeriodTime) minStartPeriodTime = item.startLessonTime
      if (!maxEndPeriodTime || item.endLessonTime > maxEndPeriodTime) maxEndPeriodTime = item.endLessonTime

      map.set(item.startLessonTime, true);
      uniquePeriods.push({
        startLessonTime: item.startLessonTime,
        endLessonTime: item.endLessonTime
      });
    }
  }

  if (uniquePeriods.length) {
    if (minEndLessonTime <= minStartPeriodTime) {
      uniquePeriods.push({ startLessonTime: minStartLessonTime, endLessonTime: minStartPeriodTime })
    }

    if (maxStartLessonTime >= maxEndPeriodTime) {
      uniquePeriods.push({ startLessonTime: maxStartLessonTime, endLessonTime: maxEndLessonTime })
    }
  }
  return uniquePeriods
}

export const sortLessonPeriods = (periods) => {
  periods = periods.sort((a, b) => parseInt(a.startLessonTime.substring(0, 2), 10) - parseInt(b.startLessonTime.substring(0, 2), 10))
  return periods
}

export const contains = (array, v) => {
  for (let i = 0; i < array.length; i++) {
    if (array[i] === v) return true;
  }
  return false;
};

export const  unique = (array) => {
  let arr = [];
  for (let i = 0; i < array.length; i++) {
    if (!contains(arr, array[i])) {
      arr.push(array[i]);
    }
  }
  return arr;
}

export const reduceGroupsBySpecialityCode = (groupData) => {
  return _.chain(groupData)
    .groupBy((group) => `${group.specialityCode} ${group.name.slice(0, -1)}`)
    .values()
    .map((groups) => {
      return _.orderBy(groups, "name", "asc")
        .reduce((pv, cv, _i, a) => a.length > 1 ?
        ({...pv,
          name: pv.name.includes("-") ? pv.name.slice(0, -1) + cv.name.slice(-1) : pv.name + "-" + cv.name.slice(-1),
          numberOfStudents: pv.numberOfStudents + cv.numberOfStudents})
        : cv)
    })
    .value();
}

export const filterScheduleByWeek = (scheduleData, filters) => {
  const weeks = []
  filters.forEach((item,index) => {
    if (item === true) weeks.push(index+1)
  })

  if (weeks.length !== 4) {
    return scheduleData.map(([day, schedule]) => {
      return ([day, schedule.filter((s) => {
          if (s.announcement || s.dateLesson !== null) return s
          else return s.weekNumber.some((w) => {return weeks.includes(w)})
        }
        )]);
    });
  } 
  
  return scheduleData;
}

export const filterScheduleBySubgroup = (scheduleData, filters) => {
  return scheduleData.map(([day, schedule]) => ([day, schedule.filter((s) => {
    if (filters[0] === true && filters[1] === true) {
      return true;
    }

    if (filters[0] === true && filters[1] === false) {
      if (s.numSubgroup === 1 || s.numSubgroup === 0) {
        return true;
      }
    }

    if (filters[0] === false && filters[1] === true) {
      if (s.numSubgroup === 2 || s.numSubgroup === 0) {
        return true;
      }
    }

    if (filters[0] === false && filters[1] === false) {
      if (s.numSubgroup === 0) {
        return true;
      }
    }

    return false;
  })]))
}

export const filterSchedule = (scheduleData, filter, typeFilter) => {
  const currentDate = new Date()
  currentDate.setHours(0,0,0,0)

  let tmp = [...scheduleData]
  if (!filter) {
    tmp = []
    scheduleData.forEach(scheduleItem => {
      const tmpLessons = []
      scheduleItem[1].forEach(lessonItem => {
        if (typeFilter === "passedLessonsFilter" && stringToDate(lessonItem.endLessonDate ? lessonItem.endLessonDate : lessonItem.dateLesson) >= currentDate) tmpLessons.push(lessonItem)
        if (typeFilter === "announcementsFilter" && !lessonItem.announcement) tmpLessons.push(lessonItem)
        if (typeFilter === "sessionFilter" && (lessonItem.announcement || lessonItem.dateLesson === null)) tmpLessons.push(lessonItem)
      })
      tmp.push([scheduleItem[0], tmpLessons])
    })
  }
  return tmp
}

export const getUniqueMonths = (data) => {
  let uniqueMonths = [];
  for (const item of data) {
    uniqueMonths.push(item.dateLesson.substr(3));
  }
  uniqueMonths = unique(uniqueMonths);

  uniqueMonths.sort((a, b) => {
    const monthAndYearArrayA = a.split('.').map(Number);
    const monthAndYearArrayB = b.split('.').map(Number);

    if (monthAndYearArrayA[1] !== monthAndYearArrayB[1]) {
      return monthAndYearArrayA[1] - monthAndYearArrayB[1];
    }
    return monthAndYearArrayA[0] - monthAndYearArrayB[0];
  });
  return uniqueMonths;
}

export const splitExamsByMonth = (exams) => {
  const uniqueMonths = getUniqueMonths(exams);

  const examsByMonth = []
  for (let i = 0; i < uniqueMonths.length; i++) {
    const tmp = []
    for (let j = 0; j < exams.length; j++) {
      if (uniqueMonths[i] === exams[j].dateLesson.substr(3))
        tmp.push(exams[j])
    }
    examsByMonth.push({
      period: uniqueMonths[i],
      exams: _.chain(_.groupBy(_.orderBy(tmp, "endLessonTime", "asc"), "dateLesson"))
        .toPairs()
        .orderBy(([d,]) => d)
        .value()
    })
  }
  return examsByMonth;
}

export const getMonthNameByNumber = (number) => {
  const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
  return months[number - 1];
}

export const getShortDayName = (dayName) => {
  const names = [{'понедельник': 'Пн'}, {'вторник': 'Вт'}, {'среда': 'Ср'}, {'четверг': 'Чт'}, {'пятница': 'Пт'}, {'суббота': 'Сб'}, {'воскресенье': 'Вс'}];
  let result = '';
  for (let i = 0; i < names.length; i++)
    if (names[i][dayName]) result = names[i][dayName];
  return result;
}

export const scheduleShouldBeClosedDueToItsDevelopment = () => {
  return todayIsInRange(3, 7, 14, 8)
}

export const ifGrayOutScheduleItem = (lesson, isOnlyCurrentWeek, isCurrentPeriod) => {
  if (isCurrentPeriod === false) {
    return false;
  }
  const datesRange = getWeekDates();
  const startLessonDate = stringToDate(lesson.startLessonDate ? lesson.startLessonDate : lesson.dateLesson);
  if (isOnlyCurrentWeek) {
    if (startLessonDate >= datesRange[0] && startLessonDate <= datesRange[5]) {
      return false;
    }
    if (startLessonDate >= new Date() || (lesson.dateLesson && startLessonDate < datesRange[0])) {
      return true;
    }
  }
  return false;
}

const getWeekDates = () => {
  const curr = new Date();
  const week = [];

  for (let i = 1; i <= 7; i++) {
    let first = curr.getDate() - curr.getDay() + i;
    let day = new Date(curr.setDate(first));
    day.setHours(0, 0, 0, 0);
    week.push(day);
  }
  week.pop();
  return week;
}

export const getStartOfEducationTerm = (scheduleTarget) => {
  if (!scheduleTarget) return null;

  const startDate = moment(scheduleTarget.startDate, DEFAULT_DATE_FORMAT);
  if (startDate.isoWeekday() === 7) {
    startDate.add(1, 'day');
  }
  return startDate;
}

export const getWeekFilterSelectionInfo = (filterWeeks, currentWeek, defaultWeek) => {
  if (!filterWeeks) return {};
  let selectedWeekIndex = null;
  for (const [index, value] of filterWeeks.entries()) {
    if (value) {
      if (selectedWeekIndex !== null) {
        return {};
      } else {
        selectedWeekIndex = index;
      }
    }
  }
  const info = {};
  if (selectedWeekIndex === currentWeek - 1) {
    info.onlyCurrentWeekSelected = true;
  }
  if (selectedWeekIndex === defaultWeek - 1) {
    info.onlyDefaultWeekSelected = true;
  }
  return info;
}

export const getShouldShowStartOfStudyWeek = (filterWeeks, defaultWeek, startOfTerm) => {
  if (!filterWeeks || !startOfTerm) return false;
  const today = moment();
  if (!today.isBefore(startOfTerm, 'day')) {
    return false;
  }

  const defaultWeekIndex = defaultWeek - 1;
  return filterWeeks[defaultWeekIndex] && filterWeeks.filter((_, index) =>
      index !== defaultWeekIndex).every(item => !item);
}
